import { JSX, ReactNode, useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { Outlet, useMatches, useNavigate } from 'react-router'

import { Box, BoxProps } from '@chakra-ui/react'




// eslint-disable-next-line @typescript-eslint/naming-convention, @stylistic/function-call-spacing
export const Alive = forwardRef<{ focus(): Promise<void> }, BoxProps & { deep: number }>
(
	(props, ref): JSX.Element =>
	{
		let matcher = useMatches()
		let navigate = useNavigate()

		let [hit, update_hit] = useState(true)

		let methods = {
			async focus ()
			{
				await navigate(0 - Math.abs(matcher.length - props.deep) )

			},

		}

		useImperativeHandle(ref, () => methods)

		useEffect(
			() =>
			{
				let deep = matcher.length - 2

				update_hit(deep === props.deep)

			},

			[matcher],

		)


		return (
			<>
				{hit || <Outlet />}

				<Box {...props} display={hit ? props.display : 'none'} />

			</>

		)

	},

)

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root (props: { children: ReactNode }): JSX.Element
{
	let w = {
		'base': 12,
		'xl'  : 36,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'2xl' : 44,

	}

	return (
		<>
			<Box w={w} float="left">{props.children}</Box>

			<Box marginLeft={w}>
				<Outlet />

			</Box>

		</>


	)


}
